import { Link } from 'react-router-dom';
import { Mail, MessageCircle, MapPin, HelpCircle, Search, UserPlus } from 'lucide-react';
import { NUMERO_RENAPDIS, URL_RENAPDIS } from '../utils/renapdis';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Columna 1: Sobre ConsultAR */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-sm">cA</span>
              </div>
              <h3 className="text-lg font-bold">ConsultAR</h3>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              La plataforma que conecta profesionales de la salud y belleza con sus pacientes.
            </p>
          </div>

          {/* Columna 2: Enlaces Rapidos */}
          <div>
            <h3 className="text-lg font-bold mb-4">Enlaces</h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/ayuda"
                  className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2"
                >
                  <HelpCircle className="w-4 h-4" />
                  Centro de Ayuda
                </Link>
              </li>
              <li>
                <Link
                  to="/search"
                  className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2"
                >
                  <Search className="w-4 h-4" />
                  Buscar Profesionales
                </Link>
              </li>
              <li>
                <Link
                  to="/register"
                  className="text-gray-400 hover:text-white transition-colors text-sm flex items-center gap-2"
                >
                  <UserPlus className="w-4 h-4" />
                  Registrarse
                </Link>
              </li>
            </ul>
          </div>

          {/* Columna 3: Contacto */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contacto</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <Mail className="w-4 h-4 flex-shrink-0" />
                noreply.consultar@gmail.com
              </li>
              <li>
                <a
                  href="https://wa.me/5493794080538?text=Hola,%20necesito%20ayuda%20con%20ConsultAR"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors flex items-center gap-2"
                >
                  <MessageCircle className="w-4 h-4 flex-shrink-0" />
                  WhatsApp: +549379408-0538
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="w-4 h-4 flex-shrink-0" />
                Corrientes, Argentina
              </li>
            </ul>
          </div>
        </div>

        {/* Linea divisoria */}
        <div className="border-t border-gray-700/50 mt-10 pt-6 text-center">
          <p className="text-gray-400 text-sm">
            &copy; 2025 ConsultAR. Todos los derechos reservados.
          </p>
          {/* Inscripción en el ReNaPDiS: en todas las páginas, en texto que
              Google lee (su IA decía que consultAR no figuraba, oct-2026) */}
          <p className="text-gray-300 text-xs mt-3">
            Recetario electrónico inscripto en el ReNaPDiS del Ministerio de Salud de la Nación · N° {NUMERO_RENAPDIS} ·{' '}
            <a href={URL_RENAPDIS} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-white">
              ver listado oficial
            </a>
          </p>
          <p className="text-gray-500 text-xs mt-2">
            ConsultAR es un producto de Gonzalez Morales Esteban Liborio - CUIT: 20-37393301-6
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;